import { render } from "./Fate.vue?vue&type=template&id=2b70d4de"
import script from "./Fate.vue?vue&type=script&lang=js"
export * from "./Fate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__